import './DataTable.css';
export var dataTable = '_14sp6az0-3-12-1';
export var firstBodyRow = '_14sp6az5-3-12-1';
export var fullWidth = '_14sp6az1-3-12-1';
export var lastBodyRow = '_14sp6az6-3-12-1';
export var notResizing = '_14sp6az2-3-12-1';
export var pinnedCellInDragOverlay = '_14sp6az4-3-12-1';
export var prefixColumn = '_14sp6az3-3-12-1';